import { Control, useController } from 'react-hook-form';
import Upload, { ItemRender, UploadFile } from '@components/common/upload';
import ErrorMessage from '@components/profile/profileOverlay/common/ErrorMessage';
import Icon from '@components/common/assets';
import { additionalBeforeUpload } from '@components/common/upload/beforeUpload';
import { useDownloadFile } from '@repository/file/useFiles';
import { AdditionInfoVO, AttachFileDtoWithFileText } from '@domain/vo/match/ResumeAdditionInfoVO';
import { allFileAllowedExtensions } from '@domain/constant/fileExtention';

import classnames from 'classnames/bind';
import styles from './additionalInputModal.module.scss';
const cx = classnames.bind(styles);

interface Props extends AdditionInfoVO {
  control: Control;
}

const AttachFile = ({ additionInfoSn, question, required, files, control }: Props) => {
  const {
    field,
    fieldState: { invalid },
    formState: { errors },
  } = useController({
    control,
    name: `${additionInfoSn}`,
    defaultValue: [] as UploadFile[],
  });

  const attachFileEls = files?.map((file) => <AttachFileItem {...file} key={file.fileUid} />);

  return (
    <div>
      <h3 className={cx('formTitle')}>
        {question}
        {required && <span className={cx('require')}>필수</span>}
      </h3>

      <div className={cx('downloadFileFormButtonWrap')}>{attachFileEls}</div>

      <Upload
        notice={
          invalid ? <ErrorMessage errors={errors} name={field.name} /> : !(field.value ?? []).length && <EmptyFiles />
        }
        type="DEFAULT"
        labelClassName={cx('fileUploadWrap', { error: invalid })}
        itemRender={uploadItem}
        multiple
        accepts={allFileAllowedExtensions}
        beforeUpload={additionalBeforeUpload}
        name={field.name}
        value={field.value ?? []}
        onChange={field.onChange}
      >
        첨부파일을 추가해주세요.
        <span className={cx('icon')} />
      </Upload>
    </div>
  );
};

export default AttachFile;

const AttachFileItem = ({ fileName, fileNameText, fileUid }: AttachFileDtoWithFileText) => {
  const { mutateAsync: downloadFile } = useDownloadFile();
  const handleDownload: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    await downloadFile({ fileUid, fileName });
  };

  return (
    <button className={cx('downloadFileFormButton')} onClick={handleDownload} key={fileUid}>
      <Icon name="uploadLight" width={16} height={16} />
      <div className={cx('fileName')}>{fileNameText}</div>
    </button>
  );
};

const EmptyFiles = () => {
  return <div className={cx('infoText')}>pdf, ppt, doc, hwp, xls, zip, jpg 파일 (50MB) 이하</div>;
};

const uploadItem: ItemRender = (_originNode, { fileName, fileUid }, _fileList, { download, remove }) => {
  const handleDownload: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
    e.preventDefault();
    download();
  };

  return (
    <div className={cx('fileListArea')} key={fileUid}>
      <div className={cx('fileListWrap')}>
        <button className={cx('fileName')} onClick={handleDownload}>
          {fileName}
        </button>
        <button
          className={cx('btnFileDelete')}
          onClick={(e) => {
            e.preventDefault();
            remove();
          }}
        >
          <Icon name="deleteLight" width={20} height={20} />
        </button>
      </div>
    </div>
  );
};
